/**
 * Rückgeld-Rechner für das Barkassieren: sinnvolle „Gegeben"-Vorschläge
 * (passend, nächster Schein) und das Rückgeld in Cent (Regel 5).
 */
const SCHEINE_CENT = [500, 1_000, 2_000, 5_000, 10_000, 20_000, 50_000];

/** Vorschläge für den gegebenen Betrag: passend, auf volle Euro/5/10 gerundet und die nächsten Scheine. */
export function gegebenVorschlaege(summeCent: number): number[] {
  if (!Number.isInteger(summeCent) || summeCent <= 0) {
    return [];
  }
  const kandidaten = new Set<number>([summeCent]);
  const volleEuro = Math.ceil(summeCent / 100) * 100;
  kandidaten.add(volleEuro);
  kandidaten.add(Math.ceil(summeCent / 500) * 500);
  kandidaten.add(Math.ceil(summeCent / 1_000) * 1_000);
  for (const s of SCHEINE_CENT) {
    if (s >= summeCent) {
      kandidaten.add(s);
    }
  }
  // Mischung: nächster Schein plus ein Schein darüber (z. B. 23,40 → 25, 30, 50)
  const naechster = SCHEINE_CENT.find((s) => s >= summeCent);
  if (naechster !== undefined) {
    const index = SCHEINE_CENT.indexOf(naechster);
    const darueber = SCHEINE_CENT[index + 1];
    if (darueber !== undefined) {
      kandidaten.add(darueber);
    }
  }
  return [...kandidaten]
    .filter((c) => c >= summeCent)
    .sort((a, b) => a - b)
    .slice(0, 6);
}

/** Rückgeld in Cent; null, wenn zu wenig gegeben wurde oder die Eingabe unbrauchbar ist. */
export function rueckgeldCent(summeCent: number, gegebenCent: number | null): number | null {
  if (gegebenCent === null || !Number.isInteger(gegebenCent) || gegebenCent < summeCent) {
    return null;
  }
  return gegebenCent - summeCent;
}

/** Stückelung des Rückgelds in Scheine und Münzen (Euro), größte zuerst. */
export function stueckelung(cent: number): { wertCent: number; anzahl: number }[] {
  const werte = [50_000, 20_000, 10_000, 5_000, 2_000, 1_000, 500, 200, 100, 50, 20, 10, 5, 2, 1];
  const ergebnis: { wertCent: number; anzahl: number }[] = [];
  let rest = Math.max(0, Math.floor(cent));
  for (const w of werte) {
    const n = Math.floor(rest / w);
    if (n > 0) {
      ergebnis.push({ wertCent: w, anzahl: n });
      rest -= n * w;
    }
  }
  return ergebnis;
}

/**
 * Plausibler „gegeben“-Betrag: höchstens das 20-fache der Summe bzw. 500 €. Größere Werte
 * stammen fast immer aus einem versehentlichen Scan (Barcode + Enter im Eingabefeld) – dann
 * wird nicht kassiert, sondern zum Prüfen aufgefordert.
 */
export function gegebenPlausibel(summeCent: number, gegebenCent: number): boolean {
  return gegebenCent <= Math.max(summeCent * 20, 50_000);
}
